import { css } from 'styled-components';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export type THBaseProps = {
    $color?: COLORS,
}

/**
 * Desktop: 40/50
 * Laptop: 32/42
 * Tablet+Mobile: 24/32
 */
export const Title = styled.p<THBaseProps>`
    width: auto;
    margin: 0;
    color: ${({ $color = 'inherit' }) => $color};

    ${FONTS.H3};

    @media (min-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H3};
        line-height: 42px;
    }

    @media (min-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3};
        line-height: 50px;
    }

`;


export const TableStyle = css`
    table {
        width: 100%;
        color: ${COLORS.TextSecondary};
        background-color: ${COLORS.BgMain};
        
        [data-view="mobile"] {
            display: none;
        }

        @media (max-width: ${wideBreakpoints.mobile}) {
            [data-view="mobile"] {
                margin-right: 6px;
                display: inline-block;
            }
        }

        > * {
            width: inherit;
            white-space: pre-wrap;
            vertical-align: middle;
        }

        &:first-child th:last-child {
            min-width: 180px;
        }
        &:first-child td:first-child {
            color: ${COLORS.TextPrimary};
            min-width: 150px;
        }

        caption {
            margin: 10px 0 12px;
            ${FONTS.H3};
        }

        thead {
            height: 72px;
            ${FONTS.M};
            padding: 6px 0;
            background-color: ${COLORS.BgSurface};

            @media (max-width: ${wideBreakpoints.mobile}) {
                display: none;
            }
        }

        tbody {
            ${FONTS.S};

            b {
                ${FONTS.MediumS};
            }
        }

        tr {
            white-space: nowrap;
            width: 1%;
            @media (max-width: ${wideBreakpoints.mobile}) {
                padding: 8px 0;
                border: 0.5px solid ${COLORS.BgSecondary};
            }
        }

        td {
            padding: 4px 12px;
            border: 0.5px solid ${COLORS.BgSecondary};
            text-wrap: balance;
            white-space: pre-line;
            word-break: break-word;
            
            @media (max-width: ${wideBreakpoints.mobile}) {
                display: block;
                border: 0;
            }
        }

        th {
            white-space: pre-wrap;
            padding: 4px 12px;
            vertical-align: middle;
            text-align: start;
        }

        a {
            ${FONTS.MediumS};
            border: none;
            border-radius: 30px;
            box-shadow: none;
            display: flex;
            justify-content: center;
            align-items: center;
            align-self: center;
            text-align: center;
            flex: 1 0 auto;
            max-width: 180px;
            padding: 12px 24px;
            background-color: ${COLORS.ButtonSecondary};
            color: ${COLORS.TextPrimary};
            margin: 0 auto;

            &:hover {
                background-color: ${COLORS.BgSecondary};
            }
            
            @media (max-width: ${wideBreakpoints.mobile}) {
                width: 100%;
                max-width: 100%;
                margin: 0 0 4px;
            }
        }
    }
`;

